// Where a NoVA citation opens. Citations are { ref, docId, title } from the
// knowledge collection; the id prefix says which surface holds the page
// (brain-, platform-, concept-, book-module-, org documents). One map for
// the backend and the dock: backend/shared/knowledgeLinks.js, copied to
// src/data by scripts/generate-entities.mjs.
// A link is never a widening: the target route enforces its own access
// (/admin/brain is operators only; the module needs the org seat).
import { knowledgeDocUrl, knowledgeDocKind } from '../data/knowledgeLinks';

export function citationHref(c, { orgId } = {}) {
  return knowledgeDocUrl(c?.docId, { orgId });
}

export function citationKind(c) {
  return knowledgeDocKind(c?.docId);
}
